// This file is automatically generated. Do not edit manually.

import { Address } from "src/api/generated/erp/db/types/embeddables/address";
import { Coordinates } from "src/api/generated/common/address/coordinates";
import { GooglePlacePrediction } from "src/api/generated/common/address/googlePlacePrediction";
import { GoogleGeocodingResult } from "src/api/generated/common/address/googleGeocodingResult";
import { OptimizedRoundTripRoute } from "src/api/generated/common/address/optimizedRoundTripRoute";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace GeocodingApi {
	export async function geocodeAddress(args: { address: Address }): Promise<Coordinates | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/address/geocoding/geocodeAddress",
			method: "POST",
			data: {
				address: args.address,
			},
		});
		return response === "" ? null : (response as Coordinates | null);
	}

	export async function geocodeAddresses(args: { addresses: Array<Address> }): Promise<Array<Coordinates | null>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/address/geocoding/geocodeAddresses",
			method: "POST",
			data: {
				addresses: args.addresses,
			},
		});
		return response as Array<Coordinates | null>;
	}

	export async function searchGooglePlaces(args: {
		input: string;
		types?: Array<string>;
		language?: string | null | undefined;
	}): Promise<Array<GooglePlacePrediction>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/address/geocoding/searchGooglePlaces",
			method: "POST",
			data: {
				input: args.input,
				types: args.types,
				language: args.language,
			},
		});
		return response as Array<GooglePlacePrediction>;
	}

	export async function geocodeGooglePlaceId(args: {
		placeId: string;
		language?: string | null | undefined;
	}): Promise<GoogleGeocodingResult | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/address/geocoding/geocodeGooglePlaceId",
			method: "POST",
			data: {
				placeId: args.placeId,
				language: args.language,
			},
		});
		return response === "" ? null : (response as GoogleGeocodingResult | null);
	}

	export async function reverseGeocodeGoogleLocation(args: {
		location: Coordinates;
		language?: string | null | undefined;
	}): Promise<GoogleGeocodingResult | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/address/geocoding/reverseGeocodeGoogleLocation",
			method: "POST",
			data: {
				location: args.location,
				language: args.language,
			},
		});
		return response === "" ? null : (response as GoogleGeocodingResult | null);
	}

	export async function optimizeRoundTripRoute(args: {
		waypoints: Array<Coordinates>;
	}): Promise<OptimizedRoundTripRoute> {
		const response = await makeAxiosRequest({
			url: "/api/ext/address/geocoding/optimizeRoundTripRoute",
			method: "POST",
			data: {
				waypoints: args.waypoints,
			},
		});
		return response as OptimizedRoundTripRoute;
	}
}
